@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

@base-color: var(--grey-550);
@hover-color: var(--grey-700);
@disabled-color: var(--grey-300);

.scale-and-dropdown {
  display: flex;
  fill: @fulfillment-planner--weight-scale--fill-color;

  .scale,
  .selector {
    &:disabled {
      cursor: default;

      .icon,
      svg {
        color: @fulfillment-planner--weight-scale--disabled--fill-color;
      }

      &:hover,
      &:focus,
      &:active {
        border-color: @fulfillment-planner--weight-scale--disabled--border-color;
        fill: @fulfillment-planner--weight-scale--disabled--fill-color;
        background-color: @fulfillment-planner--weight-scale--disabled--background-color;
      }

      border-color: @fulfillment-planner--weight-scale--disabled--border-color;
    }

    &:hover {
      border-color: @fulfillment-planner--weight-scale--hover--border-color;
      fill: @fulfillment-planner--weight-scale--hover--fill-color;
    }

    &:focus {
      border-color: @fulfillment-planner--weight-scale--focus--border-color;
      fill: @fulfillment-planner--weight-scale--focus--fill-color;
    }

    &:active {
      background-color: @fulfillment-planner--weight-scale--active--background-color;
    }
  }

  .scale {
    height: 100%;
    border-width: 1px 0 1px 1px;
    border-style: solid;
    border-color: @fulfillment-planner--weight-scale--border-color;
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    cursor: pointer;

    &:enabled:hover + div .selector {
      /* .selector left border is the center line
       *  so need to make it
       */
      border-left-color: @fulfillment-planner--weight-scale--hover--border-color;
    }

    &:enabled:focus + div .selector {
      /* .selector left border is the center line
       *  so need to make it
       */
      border-left-color: @fulfillment-planner--weight-scale--focus--border-color;
    }
  }

  .selector {
    height: 100%;
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    border: 1px solid @fulfillment-planner--weight-scale--border-color;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;

    &.smart-fill-highlighting {
      border-left: 1px solid @fulfillment-planner--weight-scale--border-color;
    }
  }

  .smart-fill-highlighting {
    border: 1px solid transparent;
    border-color: transparent;
    border-width: 0;
    border-style: none;
    background: @ship-ai--input--background-color;
  }
}

.icon {
  padding: 5px;
}

.scales {
  border-radius: 5px;
  border: 1px solid @fulfillment-planner--weight-scales--border-color;
  max-height: 250px;
  overflow: auto;
}

.caret {
  width: 12px;
  height: 12px;
  padding: 5px 10px;
}
